type IModulosDoSistema = 'modulo_base'
  | 'registro_de_ponto'
  | 'reducao_de_riscos'
  | 'calculos_e_tratamentos'
  | 'gestao_participativa'
  | 'controle_custos'
  | 'timesheet'
  | 'gestao_de_ferias_e_ausencias'
  | 'legado'


  type IFuncionalidadesDoSistema = 'notificacoes_lembrete_horario_ponto_empregado'
  | 'notificacoes_pontos_batidos_gestor'
  | 'medidas_basicas_antifraude_foto_voz_recaptcha'
  | 'medidas_avancadas_antifraude_reconhecimento_facial'
  | 'medidas_avancadas_antifraude_geolocalizacao'
  | 'medidas_avancadas_antifraude_manipulacao_horario'
  | 'medidas_avancadas_antifraude_bloqueio_ip'
  | 'notificacoes_acionaveis_gestor_atraso_hora_extra'
  | 'sobreaviso'
  | 'painel_acompanhamento_apontamentos_eventos'
  | 'solicitacoes_tratamento_folha'
  | 'solicitacoes_mudanca_escala'
  | 'solicitacoes_banco_horas'
  | 'governanca_fechamento_travamento_bilateral'
  | 'planejamento_escalas'
  | 'acompanhamento_tempo_real'
  | 'gestao_horas_extras_solicitacoes'
  | 'gestao_horas_extras_limite_acompanhamento'
  | 'gestao_horas_extras_notificacoes'
  | 'solicitacoes_ferias'
  | 'acompanhamento_ferias'
  | 'acesso_ferramenta_crisp'
  | 'acesso_seletor_internacionalizacao'
  | 'visualizar_pesquisa_de_produto'
  | 'funcionalidade_ia_dispensas'
  | 'funcionalidade_ia_calendario_ferias'
  | 'funcionalidade_ia_gestao_horas_extras'
  | 'funcionalidade_ia_politica_fechamento'
  | 'acesso_auditoria_detalhada'
  | 'acesso_auditoria_de_integracoes'
  | 'acesso_refatoracao_folha'
  | 'acesso_funcionalidade_verificar_dia'
  | 'acesso_ao_cadastro_de_biometria_facial'
  | 'acesso_banner_gestao_beta'
  | 'assistente_pontotel_habilitado'
  | 'escala_temporaria'
  | 'acesso_timesheet'
  | 'sistema_de_ponto_com_atividades'
  | 'gerar_r01_apos_travamento_unilateral'
  | 'controle_de_estacoes'
  | 'ponto_por_whatsapp'
  | 'ambiente_demo_comercial'

interface IModulos {
  [key: string]: IModulosDoSistema;
}

interface IFuncionalidades {
  [key: string]: IFuncionalidadesDoSistema;
}

const FUNCIONALIDADES: IFuncionalidades = {
  NOTIFICACOES_LEMBRETE_HORARIO_PONTO_EMPREGADO: 'notificacoes_lembrete_horario_ponto_empregado',
  NOTIFICACOES_PONTOS_BATIDOS_GESTOR: 'notificacoes_pontos_batidos_gestor',
  MEDIDAS_BASICAS_ANTIFRAUDE_FOTO_VOZ_RECAPTCHA: 'medidas_basicas_antifraude_foto_voz_recaptcha',
  MEDIDAS_AVANCADAS_ANTIFRAUDE_RECONHECIMENTO_FACIAL: 'medidas_avancadas_antifraude_reconhecimento_facial',
  MEDIDAS_AVANCADAS_ANTIFRAUDE_GEOLOCALIZACAO: 'medidas_avancadas_antifraude_geolocalizacao',
  MEDIDAS_AVANCADAS_ANTIFRAUDE_MANIPULACAO_HORARIO: 'medidas_avancadas_antifraude_manipulacao_horario',
  MEDIDAS_AVANCADAS_ANTIFRAUDE_BLOQUEIO_IP: 'medidas_avancadas_antifraude_bloqueio_ip',
  NOTIFICACOES_ACIONAVEIS_GESTOR_ATRASO_HORA_EXTRA: 'notificacoes_acionaveis_gestor_atraso_hora_extra',
  SOBREAVISO: 'sobreaviso',
  PAINEL_ACOMPANHAMENTO_APONTAMENTOS_EVENTOS: 'painel_acompanhamento_apontamentos_eventos',
  SOLICITACOES_TRATAMENTO_FOLHA: 'solicitacoes_tratamento_folha',
  SOLICITACOES_MUDANCA_ESCALA: 'solicitacoes_mudanca_escala',
  SOLICITACOES_BANCO_HORAS: 'solicitacoes_banco_horas',
  GOVERNANCA_FECHAMENTO_TRAVAMENTO_BILATERAL: 'governanca_fechamento_travamento_bilateral',
  PLANEJAMENTO_ESCALAS: 'planejamento_escalas',
  ACOMPANHAMENTO_TEMPO_REAL: 'acompanhamento_tempo_real',
  GESTAO_HORAS_EXTRAS_SOLICITACOES: 'gestao_horas_extras_solicitacoes',
  GESTAO_HORAS_EXTRAS_LIMITE_ACOMPANHAMENTO: 'gestao_horas_extras_limite_acompanhamento',
  GESTAO_HORAS_EXTRAS_NOTIFICACOES: 'gestao_horas_extras_notificacoes',
  SOLICITACOES_FERIAS: 'solicitacoes_ferias',
  ACOMPANHAMENTO_FERIAS: 'acompanhamento_ferias',
  ACESSO_FERRAMENTA_CRISP: 'acesso_ferramenta_crisp',
  ACESSO_SELETOR_INTERNACIONALIZACAO: 'acesso_seletor_internacionalizacao',
  VISUALIZAR_PESQUISA_DE_PRODUTO: 'visualizar_pesquisa_de_produto',
  FUNCIONALIDADE_IA_DISPENSAS: 'funcionalidade_ia_dispensas',
  FUNCIONALIDADE_IA_CALENDARIO_FERIAS: 'funcionalidade_ia_calendario_ferias',
  FUNCIONALIDADE_IA_GESTAO_HORAS_EXTRAS: 'funcionalidade_ia_gestao_horas_extras',
  FUNCIONALIDADE_IA_POLITICA_FECHAMENTO: 'funcionalidade_ia_politica_fechamento',
  ACESSO_AUDITORIA_DETALHADA: 'acesso_auditoria_detalhada',
  ACESSO_AUDITORIA_DE_INTEGRACOES: 'acesso_auditoria_de_integracoes',
  ACESSO_REFATORACAO_FOLHA: 'acesso_refatoracao_folha',
  ACESSO_FUNCIONALIDADE_VERIFICAR_DIA: 'acesso_funcionalidade_verificar_dia',
  ACESSO_AO_CADASTRO_DE_BIOMETRIA_FACIAL: 'acesso_ao_cadastro_de_biometria_facial',
  ACESSO_BANNER_GESTAO_BETA: 'acesso_banner_gestao_beta',
  ASSISTENTE_PONTOTEL: 'assistente_pontotel_habilitado',
  ESCALA_TEMPORARIA: 'escala_temporaria',
  ACESSO_TIMESHEET: 'acesso_timesheet',
  SISTEMA_DE_PONTO_COM_ATIVIDADES: 'sistema_de_ponto_com_atividades',
  GERAR_R01_APOS_TRAVAMENTO_UNILATERAL: 'gerar_r01_apos_travamento_unilateral',
  CONTROLE_DE_ESTACOES: 'controle_de_estacoes',
  PONTO_POR_WHATSAPP: 'ponto_por_whatsapp',
  AMBIENTE_DEMO_COMERCIAL: 'ambiente_demo_comercial',
}

const FUNCIONALIDADES_VALORES_PADRAO = {
  notificacoes_lembrete_horario_ponto_empregado: { id: null, enabled: true, value: null },
  notificacoes_pontos_batidos_gestor: { id: null, enabled: true, value: null },
  medidas_basicas_antifraude_foto_voz_recaptcha: { id: null, enabled: true, value: null },
  medidas_avancadas_antifraude_reconhecimento_facial: { id: null, enabled: true, value: null },
  medidas_avancadas_antifraude_geolocalizacao: { id: null, enabled: true, value: null },
  medidas_avancadas_antifraude_manipulacao_horario: { id: null, enabled: true, value: null },
  medidas_avancadas_antifraude_bloqueio_ip: { id: null, enabled: true, value: null },
  notificacoes_acionaveis_gestor_atraso_hora_extra: { id: null, enabled: true, value: null },
  sobreaviso: { id: null, enabled: true, value: null },
  painel_acompanhamento_apontamentos_eventos: { id: null, enabled: true, value: null },
  solicitacoes_tratamento_folha: { id: null, enabled: true, value: null },
  solicitacoes_mudanca_escala: { id: null, enabled: true, value: null },
  solicitacoes_banco_horas: { id: null, enabled: true, value: null },
  governanca_fechamento_travamento_bilateral: { id: null, enabled: true, value: null },
  planejamento_escalas: { id: null, enabled: true, value: null },
  acompanhamento_tempo_real: { id: null, enabled: true, value: null },
  gestao_horas_extras_solicitacoes: { id: null, enabled: true, value: null },
  gestao_horas_extras_limite_acompanhamento: { id: null, enabled: true, value: null },
  gestao_horas_extras_notificacoes: { id: null, enabled: true, value: null },
  solicitacoes_ferias: { id: null, enabled: true, value: null },
  acompanhamento_ferias: { id: null, enabled: true, value: null },
  // Ferramenta de suporte Crisp. Desabilitada por padrão
  acesso_ferramenta_crisp: { id: null, enabled: false, value: null },
  // Acesso ao seletor de internacionalização. Desabilitado por padrão
  acesso_seletor_internacionalizacao: { id: null, enabled: false, value: "{\"pt-BR\": true, \"es-CO\": true, \"en-US\": false}", },
  visualizar_pesquisa_de_produto: { id: null, enabled: false, value: null, },
  funcionalidade_ia_dispensas: { id: null, enabled: false, value: null, },
  funcionalidade_ia_calendario_ferias: { id: null, enabled: false, value: null, },
  funcionalidade_ia_gestao_horas_extras: { id: null, enabled: false, value: null, },
  funcionalidade_ia_politica_fechamento: { id: null, enabled: false, value: null, },
  acesso_auditoria_detalhada: { id: null, enabled: false, value: null, },
  // Libera a Auditoria de Integrações para empresas sem a integração automática Sankhya
  acesso_auditoria_de_integracoes: { id: null, enabled: false, value: null, },
  acesso_refatoracao_folha: { id: null, enabled: false, value: null, },
  acesso_funcionalidade_verificar_dia: { id: null, enabled: false, value: null, },
  acesso_ao_cadastro_de_biometria_facial: {id: null, enabled: false, value: "{\"CAMERA_RESOLUCAO_MINIMA_LARGURA\":640,\"CAMERA_RESOLUCAO_MINIMA_ALTURA\":480,\"CAMERA_MODO_DEBUG\":false,\"DETECCAO_INTERVALO_MS\":100,\"DETECCAO_AREA_MINIMA_FACE\":0.15,\"DETECCAO_AREA_MAXIMA_FACE\":0.70,\"DETECCAO_MARGEM_CENTRO\":0.05,\"DETECCAO_LIMITE_ANGULO_MAXIMO_ROTACAO_EIXO_VERTICAL\":10,\"DETECCAO_LIMITE_ANGULO_MAXIMO_ROTACAO_EIXO_HORIZONTAL\":10,\"DETECCAO_BRILHO_MINIMO\":100,\"DETECCAO_BRILHO_MAXIMO\":200,\"DETECCAO_NITIDEZ_MINIMA\":6,\"DETECCAO_CONFIANCA_MINIMA_MODELO\":0.5,\"DETECCAO_MODO_DEBUG\":false}", },
  acesso_banner_gestao_beta: { id: null, enabled: false, value: null, },
  // Assistente Pontotel (agente conversacional). Desabilitado por padrão:
  // o rollout é por tenant no Flagsmith, e o backend decide de novo a cada
  // interação — esconder aqui é UX, não autoridade.
  assistente_pontotel_habilitado: { id: null, enabled: false, value: null, },
  escala_temporaria: { id: null, enabled: false, value: null, },
  acesso_timesheet: { id: null, enabled: false, value: null },
  sistema_de_ponto_com_atividades: { id: null, enabled: false, value: null },
  gerar_r01_apos_travamento_unilateral: { id: null, enabled: false, value: null, },
  controle_de_estacoes: { id: null, enabled: false, value: null, },
  ponto_por_whatsapp: { id: null, enabled: false, value: null, },
  ambiente_demo_comercial: { id: null, enabled: false, value: null, },
}

type EstadoComFuncionalidades = {
  modulosEFuncionalidades?: {
    funcionalidades?: Partial<Record<IFuncionalidadesDoSistema, { enabled?: boolean }>>
  }
}

const funcionalidadeEstaAtiva = (
  estado: EstadoComFuncionalidades,
  funcionalidade: IFuncionalidadesDoSistema,
) => estado.modulosEFuncionalidades?.funcionalidades?.[funcionalidade]?.enabled === true

const MODULOS: IModulos= {
  BASE: 'modulo_base',
  REGISTRO_DE_PONTO: 'registro_de_ponto',
  REDUCAO_DE_RISCOS: 'reducao_de_riscos',
  CALCULOS_E_TRATAMENTOS: 'calculos_e_tratamentos',
  GESTAO_PARTICIPATIVA: 'gestao_participativa',
  CONTROLE_CUSTOS: 'controle_custos',
  TIMESHEET: 'timesheet',
  GESTAO_DE_FERIAS_E_AUSENCIAS: 'gestao_de_ferias_e_ausencias',
  LEGADO: 'legado'
}

const MODULOS_VALORES_PADRAO = {
  modulo_base: true,
  registro_de_ponto: true,
  reducao_de_riscos: true,
  calculos_e_tratamentos: true,
  gestao_participativa: true,
  controle_custos: true,
  timesheet: true,
  gestao_de_ferias_e_ausencias: true,
  legado: true
}

const OPERADORES_DE_VALIDACAO = {
  E: 'E',
  OU: 'OU'
}

const TIPO_CONDICAO = {
  MODULO: 'MODULO',
  FUNCIONALIDADE: 'FUNCIONALIDADE',
  MODULO_E_FUNCIONALIDADE: 'MODULO_E_FUNCIONALIDADE'
}

export {
  IModulosDoSistema,
  IModulos,
  MODULOS,
  MODULOS_VALORES_PADRAO,
  IFuncionalidadesDoSistema,
  IFuncionalidades,
  FUNCIONALIDADES,
  FUNCIONALIDADES_VALORES_PADRAO,
  funcionalidadeEstaAtiva,
  OPERADORES_DE_VALIDACAO,
  TIPO_CONDICAO
}
